<template>
	<div id="app">

		<router-view></router-view>

		<div v-if="loadingUser" class="loading-general">
			<div v-loading="true"></div>
		</div>

	</div>
</template>

<script>
	import Vue from 'vue'
	import axios from 'axios'
	import VueJwtDecode from 'vue-jwt-decode'

	import { mapState, mapActions, mapMutations } from 'vuex'

	import update from '@/mixins/update.js'

	import {
        login,
		setToken
    } from '@/helpers/api'

	export default {
		name: 'App',
		mixins: [update],
		data () {
			return {
				key: 1,
				msg: null,
				loadingUser: false
			}
		},
		mounted() {

			this.setConfig(window.distributionconfig)

			// Recibir archivos externos (whatsapp, gmail..etc)
			this.shareData()

			// Enviar mensaje a window.parent
			window.addEventListener("message", (event) => {
				
				if (event.data === 'reloadwindow') {
					console.log('event message from iframe: ', event)
					localStorage.removeItem('accessToken')
					window.location.reload();
				}
				
			}, false);
			
		},
		created () {
			
			//console.log('created app')

			const comp = this

			// Funciones generales para toda la app
			Vue.mixin({
				data () {
					return {}
				},
				methods: {
					openwindow(url, target) {
						let a = document.createElement("a");
						a.setAttribute('href', url);
						
						let indexFilename = url.search('filename')
						if (indexFilename > 0) {
							a.setAttribute('download', url.substring(27 + 9, url.length));
						}

						a.style = "display: none";
						a.target = target || '_blank';
						document.body.appendChild(a);  
						a.click();
						document.body.removeChild(a);
					}
				}
			})

			//Interceptor axios
			axios.interceptors.response.use((response) => {

				if(response.data && response.data.accessToken) {

					localStorage.removeItem('accessToken')
            		localStorage.setItem('accessToken', response.data.accessToken)

					setToken(response.data.accessToken);

					this.getUser()
				}

				return response;

			}, (error) => {

				// Cualquier error que no sea 401 lo ignoramos
				if (
					error.response.status !== 401 || 
					(
						error.response.status == 401 && 
						(
							error.config.url.includes('/login') 
							//|| error.config.url.includes('/datosUsuario')
						)
					)
				) {
					return new Promise((resolve, reject) => {
						reject(error);
					});
				}
				
				let rememeberExist = this.$cookies.isKey('remember')
				const _self = this
				if (rememeberExist) {
					
					return new Promise(async(resolve, reject) => {

						// Comprobamos usuario y contraseña de cookie
						let resp = await login(_self.$cookies.get('remember'));
						let token = resp.data.replace('Bearer ','')

						localStorage.removeItem('accessToken')
						localStorage.setItem('accessToken', token)
						setToken(token)	

						const config = error.config;
						config.headers['Token'] = `Bearer ${token}`;

						axios.request(config).then(response => {
							resolve(response);
						}).catch((error) => {
							reject(error);
						})
					})

				} else {

					/*console.log('abrir modal')

					// Error 401 -> abrimos modal
					const h = _self.$createElement;
					
					return new Promise((resolve, reject) => {
						this.$msgbox({
							closeOnClickModal: false,
							closeOnPressEscape: false,
							showCancelButton: false,
							showConfirmButton: false,
							message: h(ModalLogin, {on: {
								success: (token) => {

									// Cerrar modal
									_self.$msgbox.close()

									// New request with new token
									const config = error.config;
									config.headers['Token'] = `Bearer ${token}`;
									
									axios.request(config).then(response => {
										resolve(response);
									}).catch((error) => {
										reject(error);
									})
									
								}
							},key: this.key++})
						});
					})*/

					
					
				}
	  
			});

			// Inicializar
			this.getUser()

			// TEST THEME COLOR
			console.log('test theme color')
			
		},
		computed: {
			...mapState({
				sharedata: state => state.share.data
			})
		},
		methods: {
			...mapActions([
				'FETCH_USER'
			]),
			...mapMutations([
				'setConfig',
				'setUser',
				'addShareData'
			]),
			async getUser() {

				this.loadingUser = true

				if (localStorage.getItem('accessToken')) {
				
					let user = VueJwtDecode.decode(localStorage.getItem('accessToken'))
					
					this.setUser(user)
					
					//await this.FETCH_USER()
				}

				this.loadingUser = false
			},
			shareData(){
				//console.log('shareData', navigator)

				const _self = this

				if (!navigator.serviceWorker) return

				/*navigator.serviceWorker.onmessage = (event) => {
					console.log('App event: ', event.data.file)

					if(event && event.data && event.data.file) {
						_self.addShareData(event.data.file)
						_self.$router.push({ path: '/compartir' })
					}
				}*/

				navigator.serviceWorker.ready.then( registration => {
					registration.active.postMessage("get_file");
				});

				navigator.serviceWorker.addEventListener('message', event => {
					// event is a MessageEvent object
					//console.log(`The service worker sent me a message:`, event);

					if (event && event.data) {
						_self.addShareData(event.data)
						_self.$router.push({ path: '/compartir' })

						if (event.data !== 'delete file') {
							//console.log('mensaje a sw de borrar: ',event)
							navigator.serviceWorker.ready.then( registration => {
								registration.active.postMessage("delete_file");
							});
						}
						
					}
					
				});
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/scss/variables.scss';
	
	html, body {
		margin: 0px;
		color: #4a596a;
		line-height: 1.4;
		font-family: 'Nunito Sans', sans-serif!important;
	}

	* {
		min-height: 0;
		outline: 0px!important;
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		background-color: $--color-background; //#e1e5ec;
		height: 100%;
	}

	.ellipsis{
		white-space: nowrap!important;
		overflow: hidden!important;
		text-overflow: ellipsis!important;
	}

	.empty {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-flow: column;
		padding: 15px;
		flex-grow: 1;
		img {
			width: 120px;
		}
		p {
			margin: 5px 0px 0px;
			font-size: 0.8rem;
			color: #8a8a8a;
		}
	}

	.c-pointer {
		cursor: pointer;
	}

	.loading-general {
		position: absolute!important;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		z-index: 999;
		> div {
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			width: 100%;
			height: 100%;
		}
		.el-loading-mask {
			background-color: rgba(255, 255, 255, 0.33);
		}
	}

	.el-table--border::after, 
	.el-table--group::after, 
	.el-table::before {
		z-index: 0!important;
	}

	/* MESSAGE BOX */
	.el-message-box {
		width: auto;
    	max-width: 90%;
		@media(min-width: 768px) {
			width: 420px;
    		max-width: 420px;
		}
	}

	/* SCROLLBAR */
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.11); 
		-webkit-border-radius: 0px;
		border-radius: 0px;
	}

	::-webkit-scrollbar-thumb {
		transition: all 300ms 0s ease-in-out;
		-webkit-border-radius: 0px;
		border-radius: 0px;
		background-color:#00000030; 
	}
	::-webkit-scrollbar-thumb:hover {
		background-color: #0000005e; 
	}
</style>
